<!-- 发送装箱信息到信号旗 -->
<template>
  <el-dialog
    width="1200px"
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('CargoMsg.LCLList')"
  >
    <div v-if="xhqMultCustom" style="color: red;margin-bottom: 10px">{{ $t('SeaExport.MultipleCustomsDeclarationInaccurate') }}</div>
    <div style="width: 100%;">
      <div style="float: left; width: 30%;">
        <div style="height: 30px">
          <label>{{ $t('CargoMsg.IsTheLCLListSent') }}：{{ selectedContainer.xhqTaskId ? $t('CargoMsg.Cargo_Sent') : $t('CargoMsg.Cargo_NotSent') }}</label>
        </div>
        <div style="height: 30px">
          <label>{{ $t('SeaExport.ContainerNo') }}：{{ selectedContainer.containerNo }}</label>
          <label style="margin-left: 20px">{{ $t('CargoMsg.Cargo_ContainerSize') }}：{{ selectedContainer.eqSize + selectedContainer.eqType }}</label>
        </div>
        <div style="height: 30px">
          <label>
            {{ $t('CargoMsg.Cargo_VesselAndVoyage') }}：{{ job.vessel + '/' + job.voyageFlight }}
          </label>
        </div>
      </div>
      <div style="float: left; width: 40%">
        <div style="height: 40px">
          <label>
            {{ $t('CargoMsg.iEPort') }}
          </label>
          <el-select v-model="iEPort">
            <el-option :label="xhqIEPortConstants.FOREIGN_PORT_CUSTOMS.chineseName" :value="xhqIEPortConstants.FOREIGN_PORT_CUSTOMS.chineseName" />
            <el-option :label="xhqIEPortConstants.YANG_SHAN_PORT_AREA.chineseName" :value="xhqIEPortConstants.YANG_SHAN_PORT_AREA.chineseName" />
            <el-option :label="xhqIEPortConstants.WU_SONG.chineseName" :value="xhqIEPortConstants.WU_SONG.chineseName" />
          </el-select>
          <span style="margin-left: 10px">{{ $t('CargoMsg.ItIsRecommendedToFillInWhenTheExitPortIsShanghai') }}</span>
        </div>
        <div style="height: 30px">
          <label>{{ $t('SeaExport.TotalNumberOfPackages') }}：{{ totalQuantity }}</label>
          <label style="margin-left: 20px">{{ $t('SeaExport.TotalWeight') }}：{{ totalWeight }}</label>
          <label style="margin-left: 20px">{{ $t('SeaExport.TotalCubage') }}：{{ totalCubage }}</label>
        </div>
      </div>
    </div>
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :row-data="lclList"
      :column-defs="columnDefs"
      style="min-width: 160px;width:100%;height:600px;"
      @gridReady="params=>{gridApi=params.api}"
    />
    <div slot="footer">
      <el-button type="primary" :disabled="xhqMultCustom" @click="toXhqSendLCLList">{{ $t('SeaExport.Send') }}</el-button>
      <el-button @click="cancel">{{ $t('Message.Cancel2') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { xhqCheckMultCustoms, xhqSendLCLList } from '@/api/seaExport/container'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import * as xhqIEPortConstants from '@/class/cargo/model/parameters/XhqIEPortConstants'

export default {
  name: 'XhqSendContainerDialog',
  props: {
    dialogVisible: { type: Boolean, default: false },
    job: { type: Object, default: null },
    containerUsage: { type: Array, default: () => [] },
    selectedContainer: { type: Object, default: null }
  },
  data() {
    return {
      gridApi: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        suppressRowTransform: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          flex: 1
        },
        {
          headerName: this.$t('SeaExport.SoNo'),
          colId: 'soNo',
          field: 'soNo',
          flex: 1
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          colId: 'quantity',
          field: 'quantity',
          flex: 1
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          colId: 'weight',
          field: 'weight',
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          },
          flex: 1
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          },
          flex: 1
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          colId: 'remarks',
          field: 'remarks',
          flex: 1
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Tips'),
          colId: 'tips',
          field: 'tips',
          flex: 1
        }
      ],
      iEPort: '', // 出境关别
      lclList: [],
      innerVisible: false,
      container: {
        containerNo: '',
        eqSize: ''
      },
      totalWeight: 0.0,
      totalQuantity: 0,
      totalCubage: 0.0,
      xhqLclTaskInfo: {
        jobUuid: '',
        jobNo: '',
        opOffice: 0,
        containerUuid: '',
        taskId: '', // 信号旗拼箱任务Id
        iEPort: '', // 出境关别
        voyage: '', // 航次
        shipName: '', // 船名
        billNo: '', // 主单号,MB/L
        containerId: '', // 箱号
        containerMd: '', // 箱型箱种
        lclFlagCode: '', // 整拼类型
        packNo: 0, // 总件数
        grossWet: 0.0, // 总毛重
        xhqOrders: [] // 订单列表
      },
      xhqMultCustom: false
    }
  },
  computed: {
    xhqIEPortConstants() {
      return xhqIEPortConstants
    }
  },
  watch: {
    dialogVisible(newVal) {
      this.innerVisible = newVal
      if (this.dialogVisible) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:dialogVisible', newVal)
    }
  },
  async created() {
    if (this.dialogVisible) {
      this.innerVisible = true
      await this.onShow()
    }
  },
  methods: {
    async onShow() {
      this.totalWeight = 0.0
      this.totalCubage = 0.0
      this.totalQuantity = 0
      this.lclList = this.containerUsage
      const jobKeys = []
      for (const item of this.lclList) {
        this.totalWeight += item.weight
        this.totalCubage += item.cubage
        this.totalQuantity += item.quantity
        jobKeys.push(item.jobUuid)
      }
      this.totalWeight = ColumnUtils.number3ColumnLabelFunc(this.totalWeight)
      this.totalCubage = ColumnUtils.number3ColumnLabelFunc(this.totalCubage)
      this.iEPort = ''
      await xhqCheckMultCustoms(jobKeys).then(res => {
        this.xhqMultCustom = res.data
      })
    },
    cancel() {
      this.innerVisible = false
    },
    toXhqSendLCLList() {
      this.xhqLclTaskInfo.xhqOrders = []
      for (const item of this.lclList) {
        const order = {}
        order.orderOutNo = item.jobNo
        order.newBillNo = item.soNo
        order.hdPackNo = String(item.quantity)
        order.hdGrossWet = item.weight ? ColumnUtils.number3ColumnLabelFunc(item.weight) : ''
        order.hdCubage = item.cubage ? ColumnUtils.number3ColumnLabelFunc(item.cubage) : ''
        order.remarks = item.remarks
        order.tips = item.tips
        this.xhqLclTaskInfo.xhqOrders.push(order)
      }
      this.xhqLclTaskInfo.jobUuid = this.job.uuid
      this.xhqLclTaskInfo.jobNo = this.job.jobNo
      this.xhqLclTaskInfo.etd = this.job.etd
      this.xhqLclTaskInfo.containerUuid = this.selectedContainer.uuid
      this.xhqLclTaskInfo.opOffice = this.job.opOffice
      this.xhqLclTaskInfo.iEPort = this.iEPort
      this.xhqLclTaskInfo.iEPortCode = xhqIEPortConstants.getXhqIEPortByName(this.iEPort)
      this.xhqLclTaskInfo.voyage = this.job.voyageFlight
      this.xhqLclTaskInfo.shipName = this.job.vessel
      this.xhqLclTaskInfo.billNo = this.job.mbl
      this.xhqLclTaskInfo.containerId = this.selectedContainer.containerNo
      this.xhqLclTaskInfo.containerMd = this.selectedContainer.eqSize + this.selectedContainer.eqType
      this.xhqLclTaskInfo.lclFlagCode = this.job.containerLoadType
      this.xhqLclTaskInfo.packNo = this.totalQuantity
      this.xhqLclTaskInfo.grossWet = this.totalWeight
      this.xhqLclTaskInfo.cubage = this.totalCubage
      this.xhqLclTaskInfo.taskId = this.selectedContainer.xhqTaskId
      if (!this.job.customsBroker) {
        this.$message.warning(this.$t('CargoMsg.CustomsBrokerNotEntered'))
        return
      }
      this.xhqLclTaskInfo.customsBroker = this.job.customsBroker
      const loading = getLoading()
      xhqSendLCLList(this.xhqLclTaskInfo).then(res => {
        if (res.data) {
          this.$message.warning(res.data)
        } else {
          this.$message.success(this.$t('SeaExport.SendSucceeded'))
        }
      }).finally(() => {
        loading.close()
      })
      this.innerVisible = false
    }
  }
}
</script>
